module.exports = __webpack_public_path__ + "static/media/p14.98eaad2d.jpeg";